export default {
    values: {
        'An error has occurred while migrating old purge rules!':
            'An error has occurred while migrating old purge rules!',
        'Purge rules successfully migrated': 'Purge rules successfully migrated',
        'Migrate old purge rules': 'Migrate old purge rules'
    }
}
